v<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'
import Vue from 'vue'

import { deviceApi } from '@router/apiFiles/deviceApi'
import { customerApi } from '@router/apiFiles/customerApi'
import Information from '@components/information'

export default {
	page: {
		title: 'Import devices',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Information },
	data() {
		return {
			tableData: [],
			isBusy: true,
			title: 'Import devices',
			items: [
				{
					text: 'OnBoard',
					href: '/',
				},
				{
					text: 'Devices',
					href: '/',
				},
				{
					text: 'Import devices',
					active: true,
				},
			],
			customerId: '',
			customers: [],
			deviceModels: [],
			deviceModelId: '',
			toInsert: [],
			showInformation: false,
		}
	},

	mounted() {
		this.fetchData().catch(error => {
		    console.error(error)
		})
	},
	methods: {		
        async fetchData() {
			var self = this;
			self.isBusy = true;
			customerApi.searchCustomers({ search: '', page: 1, perPage: 50 })
				.then(function (data) {
					self.customers = data.data;
					self.isBusy = false;
				});
			deviceApi.searchDeviceModels({ search: '', page: 1, perPage: 50 })
				.then(function (data) {
					self.deviceModels = data.data;
					self.isBusy = false;
				});				
		},
		importFile() {
			var self = this;
			if (this.file1) {
				this.showImportFile = false;
				console.log(this.file1);
				console.log(this.file1.blob);
				var fr = new FileReader();
				fr.onload = function(e) {
					var content = e.target.result;
					var lines = content.split('\n');
					self.processFile(lines);
				}
				fr.readAsText(this.file1, "UTF-8");
			}
		},
		async processFile(lines) {
			this.isBusy = true;
			var self = this;
			self.toInsert = [];
			lines.forEach((line, index) => {
				if (line.length <= 17 && line.length > 5) {
					var id = line.replace("\r", "").replace("\n", "");
					self.toInsert.push(id);
				}
			});
			this.isBusy = false;
			this.confirmImport();
		},
		confirmImport() {
			var self = this;
			if (self.toInsert.length > 0) {
				deviceApi.createDeviceBulk({ ids: self.toInsert, modelId: self.deviceModelId, customerId: self.customerId })
					.then(function (data) {
						self.showInformation = true;
					});	
			
			}
		}
	},
}
</script>
<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<p class="text-muted font-13 mb-4"></p>
						<div class="row mb-md-2">

							<!-- Customer -->
							<div class="col-sm-6 col-md-4">
								<div class="form-group">
									<label>Customer</label>
									<div>
										<select class="form-control" v-model="customerId" style="max-width:100%">
											<option v-for="customer of customers" v-bind:key="customer.id" v-bind:value="customer.id">{{customer.name}}</option>
										</select>
									</div>
								</div>
							</div>
							<!-- End Customer -->

							<!-- Model -->
							<div class="col-sm-6 col-md-4">
								<div class="form-group">
									<label>Model</label>
									<div>
										<select class="form-control" v-model="deviceModelId" style="max-width:100%">
											<option v-for="model of deviceModels" v-bind:key="model.id" v-bind:value="model.id">{{model.name}}</option>
										</select>
									</div>
								</div>
							</div>
							<!-- End Model -->							
							
							<div class="col-sm-6 col-md-4">
								<div class="form-group">
									<label>File</label>
									<b-form-file v-model="file1" accept=".txt" :state="Boolean(file1)" placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"></b-form-file>
								</div>
							</div>


							<div class="col-sm-6 col-md-4">
								<div class="form-group">
									<b-button variant="primary" @click="importFile()" >Submit file</b-button>
								</div>
							</div>

						</div>


					</div>
				</div>
			</div>
		</div>
		
		<information informationtext="File imported!" :showDialog="showInformation" @ok="showInformation=false" />
		
	</Layout>
</template>
